import { addCompanyOss, checkCompanyOssExist } from '@/services/system/SystemController';
import { PlatformEnum, UserEnum } from '@/settings/enum';
import store from '@/store';
import { isEmpty } from '@/utils/format';
import { ModalForm, ProFormDependency, ProFormRadio, ProFormText } from '@ant-design/pro-components';
import { useRequest } from 'ahooks';
import { message } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default () => {
  const company = store.getState().platform[PlatformEnum.COMPANY];
  const token = store.getState().user[UserEnum.TOKEN];
  const platform = useSelector((state: any) => state.platform);

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const onCheckCompanyOssExist = useRequest(checkCompanyOssExist, {
    manual: true,
    defaultParams: [{ company_id: company.id }],
    onSuccess: (response) => {
      if (response === false) {
        setOpen(true);
      }
    },
  });

  useEffect(() => {
    if (isEmpty(token)) return;
    const type = platform[PlatformEnum.TYPE];
    if (type === 2) {
      onCheckCompanyOssExist.run({ company_id: company.id });
    }
  }, [platform]);

  // 初始化添加公司oss接口
  const insertCompanyOss = useRequest(addCompanyOss, {
    manual: true,
  });

  const onFinish = async (values: any) => {
    // 点击提交请求配置oss接口
    try {
      // // 调用接口请求
      await insertCompanyOss.runAsync({ ...values, id: company.id });
      message.success('配置已成功保存');
      // 刷新页面
      window.location.reload(); // 或者使用 window.location.href = window.location.href;
    } catch (error) {
      message.error('OSS目录创建失败,请联系系统管理员');
    }
  };

  const handleCancel = () => {
    // 点击取消按钮返回平台
    dispatch({ type: `${PlatformEnum.NAME}/removePlatformAll` });
    window.location.href = '/';
  };

  return (
    <ModalForm
      title="配置OSS存储"
      open={open} // Modal 总是可见
      initialValues={{
        storage_location: '2',
        // endpoint: 'http://oss-cn-beijing.aliyuncs.com',
        // access_key_id: 'LTAI5t7FYPRTMr8Q3mnVZuoa',
        // access_key_secret: 'qAuKjcvY62qaguKySP5XGWjrsJvXfO',
      }}
      modalProps={{
        onCancel: handleCancel,
      }}
      submitter={{
        searchConfig: {
          resetText: '返回平台',
          submitText: '提交',
        },
        resetButtonProps: {
          onClick: handleCancel,
        },
      }}
      onFinish={onFinish}
      layout="horizontal"
      loading={insertCompanyOss.loading}
    >
      <ProFormRadio.Group
        name="storage_location"
        layout="horizontal"
        label="OSS类型"
        labelCol={{ span: 5 }}
        options={[
          {
            label: '默认 OSS',
            value: '2',
          },
          {
            label: '自有 OSS',
            value: '1',
          },
        ]}
      />
      <ProFormDependency name={['storage_location']}>
        {/*  /!* 如果选择的是自有 OSS，显示额外的输入框 *!/*/}
        {({ storage_location }) => {
          return (
            storage_location === '1' && (
              <>
                <ProFormText
                  labelCol={{ span: 5 }}
                  name="access_key_id"
                  label="Access Key ID"
                  rules={[{ required: true, message: '请输入 Access Key ID' }]}
                />
                <ProFormText
                  labelCol={{ span: 5 }}
                  name="access_key_secret"
                  label="Access Key Secret"
                  rules={[{ required: true, message: '请输入 Access Key Secret' }]}
                />
                <ProFormText
                  labelCol={{ span: 5 }}
                  name="endpoint"
                  label="Endpoint"
                  rules={[{ required: true, message: '请输入 Endpoint' }]}
                />
              </>
            )
          );
        }}
      </ProFormDependency>
    </ModalForm>
  );
};
